/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import GlobalContext from '../../../../../components/Context/GloablContext';
import moment from "moment";

const FutureTermsModel = ({ handleClose, studentDetails }) => {
    const {isSideNavBar} = useContext(GlobalContext)

    const feeHeadLookup = studentDetails?.fee_structure?.fee_head?.reduce((acc, feeHead) => {
        if (feeHead?.fee_head_id) {
            acc[feeHead.fee_head_id] = feeHead?.feehead_name || '';
        }
        return acc;
    }, {}) || {};

    const getFeeHeadName = (fee) => (
        fee?.feehead_name
        || feeHeadLookup?.[fee?.fee_head_id]
        || '-'
    );

    const formatAmount = (value) => {
        const parsedValue = parseFloat(value);
        return Number.isFinite(parsedValue) ? parsedValue.toFixed(2) : '-';
    };

    return (
        <AnimatedModel 
            Children={
                <div data-te-modal-init="" className={`fixed bg-black bg-opacity-50 left-0 top-0  h-full ${!isSideNavBar ? "pl-[270px]" : "pl-[100px]"} z-[1055]  w-full overflow-y-auto overflow-x-hidden outline-none`} id="modalforDeactivate" tabindex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{display: "block"}}>
                    <div data-te-modal-dialog-ref="" className={`pt-[110px] pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-1 transition-all duration-300 ease-in-out mx-auto   `}>
                        <div className="pointer-events-auto flex flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600 mx-auto relative w-[820px]">
                            <div className='flex flex-shrink-0 items-center rounded-t-md bg-blue-50 py-2 px-3 mb-4'>
                                <p className='text-lg font-medium text-[#031624] text-center'>Upcoming Terms for Invoicing</p>
                                <button onClick={() => handleClose()} type="button" className="absolute right-3 box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none" data-te-modal-dismiss="" aria-label="Close">
                                    <img loading="lazy" decoding="async" src="/images/modalClose.svg" alt="icon"/>
                                </button>
                            </div>
                            <div className='overflow-y-auto scroll-bar min-h-[180px] max-h-[400px] px-4 '>
                                {studentDetails?.fee_term !== undefined &&  studentDetails?.fee_term !== null && studentDetails?.fee_term?.length !== 0 ? <div className={`flex flex-wrap -mx-2`}>
                                    {studentDetails?.fee_term?.map((term, index) => {
                                        const isBeforeDoa = moment(term?.end_date.split("T")[0]) > moment(studentDetails.date_of_admission);
                                        return (
                                            <div className="w-[50%] px-2 py2 pt-[10px]" key={index}>
                                                <div className="flex flex-col justify-between overflow-y-auto scroll-bar border border-[#D0D5DD] p-2 mb-3 rounded w-full relative">
                                                    {!isBeforeDoa && (
                                                        <p className="custom-label">
                                                            DOA beyond Term – Not Billable
                                                        </p>
                                                    )}
                                                    <div>
                                                        <p className="font-semibold px-2">{term?.term_name} ( {moment(term?.start_date.split('T')[0]).format("MMM DD, YYYY")} - {moment(term?.end_date.split('T')[0]).format("MMM DD, YYYY")} ) </p>
                                                        <div className="min-h-[72px] px-2 pt-[10px]">
                                                            {term?.fee_head?.map((fee)=>{return(<div key={fee?.fee_head_id || fee?.feehead_name} className="flex">
                                                                <p className="text-f7 py-1 font-normal text-[#171a1d] w-1/2 inline-flex">{getFeeHeadName(fee)}</p>
                                                                <p className="text-f7 py-1 text-end font-normal text-[#031624] w-1/2">{formatAmount(fee?.feehead_amount ?? fee?.amount)}</p>
                                                            </div>)})}
                                                        </div>
                                                        <hr></hr>
                                                    </div>
                                                    <div className="flex justify-items-end pt-[10px] px-2">
                                                        <p className="text-f7 font-normal text-[#031624] w-1/2 inline-flex">Total</p>                                        
                                                        <p className="text-f7 text-end font-semibold text-[#031624] w-1/2">{formatAmount(term?.total_amount)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )})}
                                </div> : <div className='flex justify-evenly items-center h-full'>
                                    <p className='p-8 mb-8 text-center'>No upcoming terms found for invoicing.</p>
                                </div>}
                            </div>
                            <div class="flex items-center justify-center my-4">
                                <button type="button" class="actn-btn1" onClick={() => handleClose()}>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    )
}

export default FutureTermsModel;